module.exports = __webpack_public_path__ + "img/gaode_logo.a27feb36.png";